import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { START_AB_TEST } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseStartAbTest } from './types'

export const useStartAbTest = (): UseStartAbTest => {
  const { t } = useTranslation('features/abTests', {
    keyPrefix: 'list.actions.startTest',
  })
  const { enqueueSnackbar } = useSnackbar()

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: START_AB_TEST,
    onCompleted: async (data: Data) => {
      const {
        startAbTest: { errors },
      } = data

      if (errors && errors.length > 0) {
        enqueueSnackbar(errors[0].message, { variant: 'error' })
      } else {
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['getAbTests'],
  })

  const startAbTest = (id: string): void => void mutateAsync({ input: { id } })

  return { startAbTest }
}
